import { all, takeLatest, put, select } from 'redux-saga/effects';

import { getToken } from '@coconut/services/redux/auth';
import { toggleSignupPopupDialog } from '@coconut/services/redux/signupDialog';

import { types, openQuestionDialogSuccess } from '../redux/questionDialog';

function* openQuestionDialogFlow() {
  const token = yield select(getToken);

  const isLoggedIn = !!token;

  if (isLoggedIn) {
    yield put(openQuestionDialogSuccess());
  } else {
    yield put(toggleSignupPopupDialog());
  }
}

export default function* () {
  yield all([takeLatest(types.OPEN_QUESTION_DIALOG, openQuestionDialogFlow)]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/questionDialog.js